import type { SheetState } from "./types";

export function removeColumnsByCategoryLabel(sheets: readonly SheetState[], categoryLabel: string): SheetState[] {
  return sheets.map((sheet) => ({
    ...sheet,
    columns: sheet.columns.filter((c) => c.categoryInstanceLabel !== categoryLabel),
  }));
}

export function updateCategoryLabelInSheets(
  sheets: readonly SheetState[],
  oldLabel: string,
  newLabel: string,
): SheetState[] {
  return sheets.map((sheet) => ({
    ...sheet,
    columns: sheet.columns.map((c) =>
      c.categoryInstanceLabel === oldLabel
        ? { ...c, categoryInstanceLabel: newLabel, label: `${newLabel}.${c.property.name}` }
        : c,
    ),
  }));
}
